export default "__VITE_ASSET__e562f434__"